import React from 'react'
import Breadcrum from './Partial/Breadcrum'
import ShopDetailContent from './Partial/ShopDetailContent'

export default function ShopDetail() {
  return (
    <>
      <Breadcrum title="Shop Details"/>
      <ShopDetailContent/>
    </>
  )
}
